const inventoryFormDetailTransformer = data => {
  return {
    formState: {
      inventory: {
        id: data?.id,
        inventoryType: data?.listingAgainst,
        project: data?.listingAgainst == "lead" ? null : data?.listingAgainstId?.toString(),
        sellerLeadId: data?.listingAgainst == "project" ? null : data?.listingAgainstId,
        purpose: data?.purposeId,
        basePrice: data?.basePrice,
        publishedPrice: data?.price,
        publishedPriceCurrency: data?.Currency ? { ...data?.Currency, value: data?.Currency?.id?.toString() } : null,
        commissionValue: data?.commissionValue,
        mouStatus: data?.mouStatus,
        mouDate: [data?.mouStartDate, data?.mouEndDate],
        attachment: { fileList: data?.mouAttachments },
        commissionType: data?.commissionType,
        externalId: data?.externalSystemId,
      },
      detail: {
        type: data?.typeId?.toString(),
        location: data?.locationSectionId ? data?.locationSectionId?.toString() : null,
        unit: data?.unitNumber,
        amenities: data?.amenities?.map(item => item?.id?.toString()),
        country: data?.Address?.countryId?.toString(),
        state: data?.Address?.state ? { label: data?.Address?.state, value: data?.Address?.stateId?.toString() } : null,
        city: data?.Address?.city ? { label: data?.Address?.city, value: data?.Address?.cityId?.toString() } : null,
        locality:
          data?.Address?.localityId === 0
            ? null
            : { label: data?.Address?.locality, value: data?.Address?.localityId?.toString() },
        phase: data?.Address?.phase,
        featureCharges: data?.FeatureCharges?.map(item => ({
          amount: item?.amount || "-",
          type: {
            label:
              item?.amountType === "none" || !item?.amountType
                ? "-"
                : item?.amountType == "fixed"
                ? "Amount"
                : "Percentage",
            value: item?.amountType,
          },
          feature: { label: item?.Feature?.name?.length ? item?.Feature?.name : "-", value: item?.Feature?.id },
          fixed: item?.fixed || null,
        })),
        beds: data?.bed,
        bath: data?.bath,
        areaUnit: data?.areaUnitId,
        landArea: (data?.landArea * data?.AreaUnit?.sqfConversion).toFixed(4),
        grossArea: (data?.grossArea * data?.AreaUnit?.sqfConversion).toFixed(4),
        photos: { fileList: data?.photos },
        documents: { fileList: data?.documents },
        floorPlans: { fileList: data?.floorPlans },
        inventoryFloorPlans: {
          list: Object.keys(data?.floorPlan).length
            ? { [data?.floorPlan?.mediaType]: [{ ...data?.floorPlan, src: data?.floorPlan?.url }] }
            : [],
          count: !!data?.floorPlan?.mediaType ? 1 : 0,
        },
      },
      setting: {
        label: data?.ListingTag?.id ? data?.ListingTag?.id?.toString() : "0",
        openTo: data?.visibility?.toString(),
        currentStatus: data?.status?.toString(),
        currentState: data?.ListingAllocationType?.id?.toString(),
        contractListing: data?.ContractListings || [],
        statusComment: data?.comments,
        listingReservationQueue: data?.listingReservationQueue,
        listingReservation: data?.listingReservation,
      },
      info: {
        floorNumber: data?.floorNumber,
        pets: data?.petRequirement,
        propertyOwnership: data?.propertyOwnership,
        occupancy: data?.occupancy,
        occupantDate: data?.vacantAt,
        construction: data?.constructionPhase,
        constructionDate: data?.constructionCompletionDate,
      },
    },
  }
}

export default inventoryFormDetailTransformer
